import { Button, Grid, IconButton, Typography } from "@mui/material";
import React, { useState } from "react";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import { useNavigate } from "react-router-dom";
import { GuestFolioSearchDrawer } from "../AdvanceOrder/GuestFolioSearchDrawer";

export const Catering: React.FC<any> = React.memo((props) => {
  const [cartOpen, setCartOpen] = useState(false);
  const navigate = useNavigate();
  const handleCartClick = () => {
    setCartOpen(true);
  };

  const handleCartClose = () => {
    setCartOpen(false);
  };

  const columns: IColumns[] = [
    {
      header: "Voucher No",
      fieldName: "workLocationName",
      tooltip: true,
    },
    {
      header: "Room",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "Guest Name",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "Tran Date",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "Date In",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "Date Out",
      fieldName: "address",
      tooltip: true,
    },
  ];

  const handleClick = (path: string) => {
    navigate(path);
  };

  return (
    <Grid container direction="column" sx={{ minHeight: "100vh" }}>
      {/* Header Section */}
      <Grid item>
        <Grid
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "16px",
          }}
        >
          {/* Title on the left */}
          <Typography variant="h6" sx={{ fontWeight: "bold", color: "green" }}>
            Inhouse Guest Folio Searching
          </Typography>
          <Grid sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <IconButton>
              <WSIcons.CreditCardIcon />
            </IconButton>
            <IconButton>
              <WSIcons.SyncIcon />
            </IconButton>
            <IconButton onClick={handleCartClick}>
              <WSIcons.SearchIcon />
            </IconButton>
            <GuestFolioSearchDrawer open={cartOpen} onClose={handleCartClose} />
            <IconButton>
              <WSIcons.CloseIcon
                sx={{ backgroundColor: "red", color: "white" }}
                onClick={() => handleClick("/")}
              />
            </IconButton>
          </Grid>
        </Grid>
      </Grid>

      {/* DataGrid Section */}
      <Grid item sx={{ flex: 1 }}>
        <WSDataGrid id="itemGrid" title="" columns={columns} />
      </Grid>

      {/* Footer Section */}
      <Grid
        item
        sx={{
          backgroundColor: "#333",
          padding: "1rem",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {/* Left-aligned items: icon and one button */}
        <Grid
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "1rem", // space between icon and button
          }}
        >
          <WSIcons.GTranslateIcon sx={{ color: "white" }} />
          <Typography color={"white"}>Credit Limit Balance</Typography>
        </Grid>

        {/* Right-aligned items: two buttons */}
        <Grid
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "1rem", // space between the buttons
          }}
        >
            <Button
            variant="outlined"
            color="success"
          >
            Change Room
          </Button>
            <Button
            variant="outlined"
            color="success"

          >
            Edit
          </Button>
             <Button
            variant="outlined"
            color="success"

          >
            Post
          </Button>
          <Button
            variant="contained"
            color="success"

          >
            Finish
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
});
